import * as React from 'react'

export const SvgCashApp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 2"
    viewBox="0 0 34 24.1"
    {...props}
  >
    <title>CashApp</title>
    <g data-name="Layer 1">
      <rect width="34" height="24.1" rx="4" fill="#53b04d" />
      <path
        d="m22.55 8.24-1.39 1.14c-.13.1-.3.08-.39-.05-.71-.87-1.81-1.37-3.02-1.37-1.34 0-2.18.59-2.18 1.41-.02.7.63 1.06 2.64 1.49 2.54.54 3.7 1.59 3.7 3.37 0 2.23-1.81 3.87-4.65 4.05l-.28 1.32c-.02.13-.14.22-.28.22h-2.18a.29.29 0 0 1-.28-.34l.34-1.47c-1.4-.4-2.54-1.18-3.19-2.13-.08-.13-.06-.29.06-.38l1.52-1.19c.13-.1.31-.07.4.06.8 1.12 2.04 1.79 3.54 1.79 1.34 0 2.35-.65 2.35-1.59 0-.72-.51-1.06-2.22-1.41-2.92-.63-4.08-1.7-4.08-3.48 0-2.06 1.73-3.61 4.35-3.82l.29-1.37c.02-.13.14-.22.28-.22h2.15c.17 0 .31.16.28.33l-.33 1.53c1.13.34 2.04.96 2.62 1.73.09.11.07.29-.05.38Z"
        fill="#fff"
        fill-rule="evenodd"
      />
    </g>
  </svg>
)
export default SvgCashApp
